import {gsap, Expo} from 'gsap';
import { ShuffleText } from '../_main'

class OpeningAnimation {
  constructor(el) {
    this.dom = {el: el}
    this.dom.cover = this.dom.el.querySelector('[data-js="visual-cover"]');
    this.dom.image = this.dom.el.querySelector('[data-js="visual-image"]');

    this.shuffleCodesAry = [];
    this.shuffleCodes = document.querySelectorAll('[data-js="code-shuffle"]');
    if (this.shuffleCodes) {
      [...this.shuffleCodes].forEach(el => {
        this.shuffleCodesAry.push(new ShuffleText(el));
      });
    }
  
    this.init();
  }

  init() {

    [...this.shuffleCodesAry].forEach((code, i) => {
      code.start(i);
    })

    gsap.to(this.dom.cover, {
      alpha: 1,
      duration: 3
    })

    gsap.to(this.dom.image, {
      alpha: 1,
      scale: 1,
      duration: 1.8,
      delay: 2,
      ease: 'Expo.easeOut'
    })

    gsap.to(this.shuffleCodes, {
      alpha: 0,
      duration: 3,
      delay: 2.4,
    })
  }
}

export default OpeningAnimation